type MetricsWindow = Window & {
  __forfeoResponsiveMetricsV1?: boolean;
};

if (typeof window !== "undefined" && typeof document !== "undefined") {
  const metricsWindow = window as MetricsWindow;

  if (!metricsWindow.__forfeoResponsiveMetricsV1) {
    metricsWindow.__forfeoResponsiveMetricsV1 = true;

    const root = document.documentElement;
    let header: Element | null = null;
    let footer: Element | null = null;
    let headerObserver: ResizeObserver | null = null;
    let footerObserver: ResizeObserver | null = null;
    let frame = 0;

    const update = () => {
      const headerHeight = header
        ? Math.ceil(header.getBoundingClientRect().height)
        : 0;

      const footerHeight = footer
        ? Math.ceil(footer.getBoundingClientRect().height)
        : 0;

      root.style.setProperty(
        "--header-h",
        String(headerHeight) + "px",
      );

      root.style.setProperty(
        "--fixed-footer-h",
        String(footerHeight) + "px",
      );
    };

    const bind = () => {
      const nextHeader = document.querySelector(
        "[data-forfeo-main-header]",
      );

      const nextFooter = document.querySelector(
        "[data-forfeo-fixed-footer]",
      );

      if (nextHeader !== header) {
        headerObserver?.disconnect();
        header = nextHeader;

        if (header && typeof ResizeObserver !== "undefined") {
          headerObserver = new ResizeObserver(update);
          headerObserver.observe(header);
        }
      }

      if (nextFooter !== footer) {
        footerObserver?.disconnect();
        footer = nextFooter;

        if (footer && typeof ResizeObserver !== "undefined") {
          footerObserver = new ResizeObserver(update);
          footerObserver.observe(footer);
        }
      }

      update();
    };

    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(bind);
    };

    const styleId = "forfeo-responsive-layout-metrics";

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent =
        "body{padding-bottom:var(--fixed-footer-h,0px)}";
      document.head.appendChild(style);
    }

    bind();

    new MutationObserver(schedule).observe(
      document.documentElement,
      { childList: true, subtree: true },
    );

    window.addEventListener("resize", schedule, {
      passive: true,
    });
  }
}

export {};
